import React, { useState } from 'react';
import AppImage from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const PhotoCarousel = ({ media = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const photos = media?.filter(m => m?.type === 'photo') || [];
  const displayPhotos = photos?.length > 0 ? photos : [
    { id: '1', original_url: '/assets/images/no_image.png', enhanced_url: null }
  ];

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? displayPhotos?.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev === displayPhotos?.length - 1 ? 0 : prev + 1));
  };

  const currentPhoto = displayPhotos?.[currentIndex];
  const imageUrl = currentPhoto?.enhanced_url || currentPhoto?.original_url;

  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden">
      <div className="relative h-96 md:h-[500px] bg-muted">
        <AppImage
          src={imageUrl}
          alt={`Property photo ${currentIndex + 1}`}
          className="w-full h-full object-cover"
        />
        
        {displayPhotos?.length > 1 && (
          <>
            <button
              onClick={goToPrevious}
              className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-card/90 backdrop-blur-sm border border-border flex items-center justify-center hover:bg-card transition-colors"
              aria-label="Previous photo"
            >
              <Icon name="ChevronLeft" size={20} color="currentColor" />
            </button>
            
            <button
              onClick={goToNext}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-card/90 backdrop-blur-sm border border-border flex items-center justify-center hover:bg-card transition-colors"
              aria-label="Next photo"
            >
              <Icon name="ChevronRight" size={20} color="currentColor" />
            </button>

            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-card/90 backdrop-blur-sm px-3 py-1 rounded-full text-sm">
              {currentIndex + 1} / {displayPhotos?.length}
            </div>
          </>
        )}
      </div>

      {displayPhotos?.length > 1 && (
        <div className="p-4 flex gap-2 overflow-x-auto">
          {displayPhotos?.map((photo, index) => (
            <button
              key={photo?.id || index}
              onClick={() => setCurrentIndex(index)}
              className={`flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 transition-all ${
                index === currentIndex ? 'border-primary' : 'border-transparent opacity-60 hover:opacity-100'
              }`}
            >
              <AppImage
                src={photo?.enhanced_url || photo?.original_url}
                alt={`Thumbnail ${index + 1}`}
                className="w-full h-full object-cover"
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PhotoCarousel;